import React from 'react';
import { Text, Circle, useTheme } from 'native-base';
const twoDigitsMaximum = 99;
const CircleText = (count, type) => {
  const theme = useTheme(),
    {
      colors
    } = theme;
  let bg, left, right, top;
  top = count > twoDigitsMaximum ? -10 : -8;
  if (type === 'notifications') {
    bg = colors.notification.circle.notification;
    right = count > twoDigitsMaximum ? -10 : -6;
    top = count > twoDigitsMaximum ? -10 : -8;
  } else {
    bg = colors.notification.circle.other;
    left = count > twoDigitsMaximum ? -10 : -6;
    top = count > twoDigitsMaximum ? -10 : -8;
  }
  return /*#__PURE__*/React.createElement(Circle, {
    size: count > twoDigitsMaximum ? '28px' : '24px',
    position: 'absolute',
    bg: bg,
    top: top,
    left: left,
    right: right
  }, /*#__PURE__*/React.createElement(Text, {
    color: colors.notification.text,
    fontSize: 'xs'
  }, count));
};
export default CircleText;
//# sourceMappingURL=CircleText.js.map